import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="Footer">
      <p>&copy; 2025 Acolyte's Chorus. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
